"use client"

import { useState, useEffect } from "react"
import "../assets/css/navbar.css"
import Logo from "../assets/images/logo.jpg"

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const navItems = [
    "Products",
    "Services",
    "About",
    "Upcoming",
    "Contact",
    // "Export",
    // "Investments",
    "Join Our Team"
  ]

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <a href="/" className="logo-link">
          <div className="logo">
            <img src={Logo} alt="Logo" className="logo-image" />
            <span>Green Beat Ceylon</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navItems.map((item) =>
            item === "Join Our Team" ? (
              <a
                key={item}
                href="/careers"
                className={`nav-link ${isScrolled ? "scrolled" : ""}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item}
              </a>
            ) : item === "Export" ? (
              <a
                key={item}
                href="/export"
                className={`nav-link ${isScrolled ? "scrolled" : ""}`}
              >
                {item}
              </a>
            ) :  item === "Investments" ? (
              <a
                key={item}
                href="/investments"
                className={`nav-link ${isScrolled ? "scrolled" : ""}`}
              >
                {item}
              </a>
            ) :
            (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className={`nav-link ${isScrolled ? "scrolled" : ""}`}
              >
                {item}
              </a>
            )
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 12H21M3 6H21M3 18H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav">
          <div className="container">
            {navItems.map((item) =>
              item === "Join Our Team" ? (
                <a
                  key={item}
                  href="/careers"
                  className="mobile-nav-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </a>
              ) : item === "Export" ? (
                <a
                  key={item}
                  href="/export"
                  className="mobile-nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </a>
              ) : (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="mobile-nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </a>
              )
            )}
          </div>
        </div>
      )}
    </header>
  )
}
